import {Button, FullscreenPanel, FullscreenPanelBody, Modal} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import React, {memo, useCallback} from 'react'

import {useConfigContext} from '../../../../contexts'
import {DraggableAddresses} from '../../../../widgets/RouteInfo/components/draggable-addresses/DraggableAddresses'
import {RouteInfo} from '../../../../widgets/RouteInfo/RouteInfo'
import {useRouteInfo} from '../../../../widgets/RouteInfo/useRouteInfo'
import * as classes from './EditOrderOfPointsModal.classes'
import type {Props} from './types'

export const EditOrderOfPointsModal = memo<Props>(function EditOrderOfPointsModal(props) {
  const {isActive, setActive} = props
  const {device} = useConfigContext()
  const i18n = useI18n()

  const close = useCallback(() => {
    setActive?.(false)
  }, [setActive])

  const {routeInfoRef, addresses, handleSave, setAddresses} = useRouteInfo({
    onSave: close,
  })

  return device === 'mobile' ? (
    <FullscreenPanel anchor="bottom" opened={isActive}>
      <FullscreenPanelBody>
        <RouteInfo
          ref={routeInfoRef}
          addresses={addresses}
          onClose={close}
          onSave={handleSave}
          setAddresses={setAddresses}
          fullscreen
        />
      </FullscreenPanelBody>
    </FullscreenPanel>
  ) : (
    <Modal className={classes.modal} onClose={close} opened={isActive}>
      <Modal.Header title={i18n('bdui.route.title', 'Маршрут')} />
      <Modal.Body ref={routeInfoRef}>
        <DraggableAddresses addresses={addresses} fullscreen={false} setAddresses={setAddresses} />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Controls>
          <Button onPress={handleSave} size="l" variant="action" fullWidth>
            {i18n('bdui.route.ready', 'Готово')}
          </Button>
        </Modal.Footer.Controls>
      </Modal.Footer>
    </Modal>
  )
})
